import {useCallback, useEffect, useMemo, useState} from 'react';
import {CategoryItem} from '../CategoryItem/CategoryItem';
import {ExploreSection} from '../ExploreSection/ExploreSection';

const getCategoryId = (category) =>
  (category.display_name || category.title).toLowerCase().replaceAll(' ', '-');

export const SubCategories = ({subCategories, open, navLevel, setLevel1Category, setNavLevel}) => {
  const subCategoriesWithoutExplore =
    subCategories?.filter((subCategory) => !subCategory?.name?.includes('explore_')) || [];

  const [expandedCategoryId, setExpandedCategoryId] = useState(
    subCategoriesWithoutExplore.length === 1 ? getCategoryId(subCategoriesWithoutExplore[0]) : null
  );

  useEffect(
    () => () => {
      setExpandedCategoryId(null);
    },
    []
  );

  const onToggleExpand = useCallback((categoryId) => {
    setExpandedCategoryId((prevId) => (prevId === categoryId ? null : categoryId));
  }, []);

  const subCategoriesMemo = useMemo(
    () =>
      subCategoriesWithoutExplore.map((subCategory) => {
        const subCategoryId = getCategoryId(subCategory);
        const isExpanded = expandedCategoryId === subCategoryId;

        return (
          <CategoryItem
            key={subCategory.display_name || subCategory.title}
            category={subCategory}
            title={subCategory.display_name || subCategory.title}
            linkTabIndex={open && navLevel === 1 ? 0 : -1}
            level={1}
            setLevel1Category={setLevel1Category}
            setNavLevel={setNavLevel}
            isExpanded={isExpanded}
            onToggleExpand={() => onToggleExpand(subCategoryId)}
          />
        );
      }),
    [
      subCategoriesWithoutExplore,
      expandedCategoryId,
      open,
      navLevel,
      setLevel1Category,
      setNavLevel,
      onToggleExpand,
    ]
  );

  if (!subCategories) return null;

  return (
    <div>
      <ExploreSection subCategories={subCategories} />
      {subCategoriesMemo}
    </div>
  );
};
